/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useMediaQuery } from '@material-ui/core';
import cx from 'classnames';
import ContentWrapper from '../ContentWrapper/ContentWrapper';
import styles from './Footer.module.scss';
import { getTranslation } from '../../utils/functions';
import {
  footerSelector,
  primaryColorSelector,
} from '../../store/selectors/globalConfigSelectors';
import { languageSelector } from '../../store/selectors/appSelectors';
import RPLFooter, {
  FooterVariants,
} from '@hid-galaxy-ui/galaxy-react/components/Footer';

const Footer = () => {
  const { language, footer } = useSelector((state) => ({
    // primaryColor: primaryColorSelector(state),

    language: languageSelector(state),
    footer: footerSelector(state),
  }));
  // const isMobileView = useMediaQuery((theme) => theme.breakpoints.down('xs'));
  // const themeStyles = {
  //   background: primaryColor,
  // };

  const [detectChangeLanguage, setDetectChangeLanguage] = useState(true);

  const footerLinks = (links) => {
    if (links.length === 0) return null;
    return links.map((link, index) => {
      return {
        text: getTranslation(link.label),
        link: getTranslation(link.url),
      };
    });
  };

  useEffect(() => {
    setDetectChangeLanguage(true);
  }, [language]);

  return (
    <>
      {
        // <div style={themeStyles}>
        <RPLFooter
          mode={FooterVariants.Base}
          primaryText={
            footer?.copyrightText
              ? `${getTranslation(footer?.copyrightText)}`
              : '©2025 SKIDATA/ASSA ABLOY. All rights reserved.'
          }
          linkText={footerLinks(footer?.links || [])}
        />
        // </div>
        // <footer className={styles.footer} style={themeStyles}>
        //   <ContentWrapper
        //     className={cx(styles.footerContent, {
        //       [styles.footerContent__mobile]: isMobileView,
        //     })}
        //   >
        //     <p className={styles.text}>
        //       {footer.copyrightText && getTranslation(footer.copyrightText)}
        //     </p>
        //     {footerLinks(footer.links || [])}
        //   </ContentWrapper>
        // </footer>
      }
    </>
  );
};

export default Footer;
